module.exports = __webpack_public_path__ + "media/images/icon__teaserSampleBetInfo-a9b5d181eda801363728fd78e6baddc5.png";